import { FC } from 'react';
import { useTranslation } from 'react-i18next';
import { Button } from 'shared/components/Button.tsx';
import { ArrowIcon, CalendarIcon, MsTeamsLogo, WatchIcon } from 'shared/icons';
import { MeetingType } from 'types/Meeting/MeetingType.ts';

const TableUpcomingMeeting: FC<{ url: string }> = ({ url }) => {
  return (
    <a target="_blank" href={url} rel="noreferrer">
      <button className="hidden items-center justify-center rounded-lg bg-lightBlue p-2.5 text-primary sm:flex xl:hidden">
        <CalendarIcon className="h-4 w-4" />
      </button>
    </a>
  );
};

export const UpcomingMeeting: FC<MeetingType> = ({ url, displayTime, displayDate, title }) => {
  const { t } = useTranslation();

  return (
    <>
      {url && <TableUpcomingMeeting url={url} />}
      <div className="block space-y-4 rounded-md bg-white p-3 text-xs sm:hidden xl:block">
        <div className="flex items-start justify-between">
          <p className="font-bold">{t('common:navbar.upcomingMeeting')}</p>
          <MsTeamsLogo className="w-5 min-w-5" />
        </div>
        <div className="space-y-2 text-gray-500">
          <p>{title}</p>
          <p className="flex space-x-2">
            <CalendarIcon className="w-4 text-primary" /> <span>{displayDate}</span>
          </p>
          <p className="flex space-x-2">
            <WatchIcon className="w-4 text-primary" /> <span>{displayTime}</span>
          </p>
        </div>
        {url && (
          <a target="_blank" href={url} rel="noreferrer" className="block">
            <Button className="w-full space-x-2">
              <span>{t('action:join')}</span>
              <ArrowIcon className="w-5 rotate-180 text-white" />
            </Button>
          </a>
        )}
      </div>
    </>
  );
};
